// TODO.md U-18. The one change that let `script_src` drop `unsafe_inline`.
//
// 🚨 **jQuery's `$.getScript` creates a `<script>` element with NO nonce, and a nonce-based `script-src`
// refuses it.** `jquery.js:9980` (3.7.1) registers the `"text script"` converter as
// `function (text) { jQuery.globalEval(text); return text }` — no second argument, so `DOMEval` has no
// nonce to copy onto the element it builds. 48 call sites across the packs went through that one converter.
//
// 🔑 **jQuery supports this explicitly; it is not a hack.** `DOMEval` copies `nonce` out of
// `preservedScriptAttributes` (`jquery.js:97-127`), and the comment at `jquery.js:122` says the
// `getAttribute` check exists "for the sake of `jQuery.globalEval` so that it can fake a nonce-containing
// node via an object". The second argument is the supported route.
//
// 📌 **`rails-ujs` needed nothing** — it already does `script.setAttribute("nonce", cspNonce())`
// (`rails-ujs.js:155`), so all 43 `.js.erb` templates were compliant before this file existed. Only the
// jQuery path was short, which is why the item's "44 .js.erb templates and growing" measurement was the
// wrong thing to count.
//
// ⚠️ **Read lazily, inside the converter.** The nonce is session-stable today (see
// `config/initializers/content_security_policy.rb`), so a value captured at install time would in fact
// work — but capturing it means this file silently stops working if that generator ever becomes
// per-request, and the failure would be every `$.getScript` on every page after the first navigation.
// Resolving per call costs one `querySelector` on an action the user initiated.
// 📌 Not exported: both callers are in this file. `/simplify` flagged the unused export as `T-91`'s
// shape — an import that is never called, which is what made a false claim plausible there.
const cspNonce = () => {
  const meta = document.querySelector('meta[name="csp-nonce"]')

  return (meta && meta.content) || ''
}

// ⚠️ `ajaxSetup` deep-merges `converters` (it is not in jQuery's `flatOptions`), so naming one key keeps
// `text json`, `text html` and the rest. Replacing the whole `converters` object would break them.
export default () => {
  $.ajaxSetup({
    converters: {
      'text script': function (text) {
        $.globalEval(text, { nonce: cspNonce() })

        return text
      }
    }
  })
}

// 🚨 **TODO.md U-18. The THIRD executor, and my census missed it.** The `.js.erb` responses were counted
// twice — 43 via rails-ujs, 48 via `$.getScript` — and two call sites run one by **hand**: the customer
// delete and the quality-control delete fetch `text/javascript` with superagent and inject it themselves.
// Under a nonce policy a hand-built `<script>` with no nonce is **refused**, so the delete's response never
// ran: no toast, no navigation, and to the user nothing happened at all.
// 🔑 **Caught by the full suite, not by either of my guards** (`spec/features/normal/customer/quality_controls_spec.rb`
// → *delete quality control PP*, seed 764338363) — a lint that enumerates the executors it knows about
// cannot find the one nobody thought of. `spec/config/csp_script_injection_spec.rb` now forbids a bare
// `createElement('script')` in the packs so a fourth cannot appear the same way.
// ⚠️ Why these two do not use `$.getScript`: the response navigates, and they need the superagent promise's
// `.catch` for `handleErrors` plus `deleteRecord`'s early `dirty` clear (`T-111`). Keep the shape, add the
// nonce.
export const runScriptResponse = (text) => {
  const script = document.createElement('script')
  const nonce = cspNonce()

  if (nonce) script.setAttribute('nonce', nonce)
  script.textContent = text
  document.head.appendChild(script)
  script.remove()
}
